"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;
const PRODUCTS = exports.PRODUCTS = 'products';
